/**
 * The game's ONE back button and ONE sound button (OD-030, OD-033 — Marko 22.9.2026): the Profile edit screen's own
 * pieces and markup, used by every view. "Logiikka ja elementit tulisi olla yhteisiä, jos ne on ns sama painike tai
 * elementti. Säästetään muistia ja jos on tarve tehdä muutos, niin muuttuu kaikkialle kerralla." No view draws its own
 * back or sound any more — not as a piece, not as a hit box over a painted disc, not as another picture.
 *
 * Two layers at one box, the owner's method (21.9.2026): one disc (a single file; the right-hand disc is its CSS mirror,
 * `.ui-head.right`) and the icon on top, both centred by the stylesheet. Back stands top-left at 16,9; sound top-right at
 * 812,9 whenever the corner is free ("Sound painike pitää olla aina oikeassa yläkulmassa jos sille on tilaa"); a view
 * whose corner is taken passes `at`.
 */
import { art } from '../art';
import { muted, setMuted } from '../state/store';
import { unlockAudio } from '../audio/sfx';

export const HEAD = {
  back:  { left: 16,  top: 9, width: 120, height: 120 },
  sound: { left: 812, top: 9, width: 120, height: 120 },
} as const;

/** The back button. The caller owns the navigation and its tap sound (many views already play it in `leave`/`go`). */
export function HeadBack({ onClick, testid = 'btn-back', label = 'Back' }: { onClick: () => void; testid?: string; label?: string }) {
  return (
    <button class="ui-head" type="button" data-testid={testid} aria-label={label} style={HEAD.back} onClick={onClick}>
      <img class="uh-bg" src={art('/art/ui-head/bg@2x.png')} alt="" draggable={false} />
      <img class="uh-ic" src={art('/art/ui-head/icon-back@2x.png')} alt="" draggable={false} />
    </button>
  );
}

/** The sound button: mounted once by the app shell (top-right); a view whose top-right is taken mounts it at `at` and
 *  hides the shell's copy with its body class. `.mute` keeps it under the sheet scrim (app.css). */
export function HeadSound({ at, artBox }: {
  at?: { left: number; top: number };
  /** a view's own image box inside the control (Codex FIX-3 §4): REMATCH draws the disc at 116.617 */
  artBox?: { left: number; top: number; size: number };
} = {}) {
  return (
    <button class="ui-head right mute" type="button" data-testid="mute" aria-label={muted.value ? 'Sound off' : 'Sound on'} style={at ? { ...HEAD.sound, ...at } : HEAD.sound}
      onClick={() => { unlockAudio(); setMuted(!muted.value); }}>
      <img class="uh-bg" src={art('/art/ui-head/bg@2x.png')} alt="" draggable={false} style={artBox ? { left: artBox.left, top: artBox.top, width: artBox.size, height: artBox.size, transform: 'scaleX(-1)' } : undefined} />
      <img class="uh-ic" src={art(`/art/ui-head/icon-sound-${muted.value ? 'off' : 'on'}@2x.png`)} alt="" draggable={false} style={artBox ? { left: artBox.left, top: artBox.top, width: artBox.size, height: artBox.size, transform: 'none' } : undefined} />
    </button>
  );
}
